<template>
	<div class="sky-tabs" :class="[customClass ? 'custom-class' : '', className]">
		<el-tabs v-model="activeName" v-bind="$attrs" @tab-click="handleClick">
			<el-tab-pane
				v-for="item in tabList"
				:key="item.name"
				:label="item.label"
				:name="item.name"
				v-bind="item"
			></el-tab-pane>
		</el-tabs>
		<slot></slot>
	</div>
</template>

<script>
export default {
	name: 'sky-tabs',
	model: {
		prop: 'value',
		event: 'change',
	},
	props: {
		value: {
			required: true,
		},
		tabList: {
			required: true,
			type: Array,
		},
		customClass: {
			default: true,
		},
		className: {
			required: false,
		},
	},
	data() {
		return {
			activeName: '',
		};
	},
	watch: {
		value: {
			handler(val) {
				this.activeName = val;
			},
		},
	},
	methods: {
		handleClick(tab, event) {
			this.$emit('change', tab.name);
			this.$emit('changeTab', tab, event);
		},
	},
	mounted() {
		this.activeName = this.value;
	},
};
</script>

<style lang="scss" scoped>
.sky-tabs {
	padding: 0 25px;
	// display: flex;
	align-items: center;
}
</style>

<style>
.custom-class .el-tabs__nav-wrap::after {
	display: none;
}
.custom-class .el-tabs__item {
	font-size: 16px;
	font-weight: bold;
}
.custom-class .el-tabs__header {
	margin: 0 !important;
}
</style>
